import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EmailApiService } from '../services/email-api.service';
import { ActivatedRoute } from '@angular/router';
import { ButtomLogoComponent } from '../shared/buttom-logo/buttom-logo.component';

@Component({
  selector: 'app-created',
  imports: [FormsModule, ButtomLogoComponent],
  templateUrl: './created.component.html',
  styleUrl: './created.component.css',
})
export class CreatedComponent {
  constructor(
    private emailApiService: EmailApiService,
    private route: ActivatedRoute
  ) {}

  email = signal('');

  ngOnInit() {
    const queryIdValue = this.route.snapshot.queryParamMap.get('id');
    if (queryIdValue) {
      this.emailApiService.getDisposableEmail(queryIdValue)
        .subscribe({
          next: (response) => {
            console.debug('CreatedComponent: response', response);
            if (response.disposableEmail) {
              this.email.set(response.disposableEmail);
            }
          },
          error: (err) => {
            console.error('CreatedComponent: error', err);
          },
        });
    }
  }

  handleCopy() {
    navigator.clipboard
      .writeText(this.email())
      .then(() => {})
      .catch((err) => {
        console.error(err);
      });
  }
}
